import React, { ReactElement } from 'react';
import { Typography } from '@wds/typography';
import { Immutable, safeRest } from '@wds/utils';
import { defineMessages, t } from '@sm/intl';
import useStyles from './useStyles';

export type TitleProps = Immutable<{
  children?: React.ReactNode;
  titleLabel?: string;
}>;

export const COPY = defineMessages({
  TITLE: {
    id: 'Title.TitleLabel',
    defaultMessage: 'Title of page',
    description:
      '[Type: Label][Vis.: high] - This is the page title on the header.',
  },
});

export const Title = ({
  children,
  titleLabel = t(COPY.TITLE),
  ...rest
}: TitleProps): ReactElement => {
  const classes = useStyles();

  return (
    <div className={classes.title} {...safeRest(rest)} aria-label={titleLabel}>
      <Typography variant="cardTitle" color="light">
        <strong>{children}</strong>
      </Typography>
    </div>
  );
};
